import React from 'react';
import clsx from 'clsx';
import {Grid} from '@mui/material';
import { Card, Chip, Typography } from '@curves/ui-base';

import {ReadTextField} from '@Local/Components';
import {ORDER_STATUS_COLOR_MATCH} from '@Constants/appConfig';
import {formatCurrencyFn} from '@Util/utils';
/**
 * 訂單付款資訊區塊組件
 *
 * 功能：
 * - 顯示訂單相關的付款資訊
 * - 包含付款狀態、金額、方式等資訊
 *
 * @component
 * @param {Object} props - 組件屬性
 * @param {string} props.className - 自定義樣式類名
 * @param {Object} props.paymentData - 付款資料
 * @returns {JSX.Element} 付款資訊區塊
 */
const OrderPaymentInfoSection = ({className,paymentData}) => {
    return (
        <Card className={clsx("px-3 pt-2 pb-3", className)}>
            <Card.CardContent>
                <Typography variant="body1" color={'text-secondary'} className={'mb-2'}>
                    付款資訊
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <ReadTextField label="訂單金額">
                            {formatCurrencyFn(paymentData?.payablePrice, {symbol: '$'})}
                        </ReadTextField>
                    </Grid>
                    <Grid item xs={6}>
                        <ReadTextField label="付款狀態">
                            <Chip label={paymentData?.paymentStatusText} color={ORDER_STATUS_COLOR_MATCH[paymentData?.paymentStatusColor]}/>
                        </ReadTextField>
                    </Grid>
                    <Grid item xs={6}>
                        <ReadTextField label="現金付款金額">
                            <span className={Number(paymentData?.cashPayment) > 0 ? 'font-weight-bold text-success' : ''}>
                                {formatCurrencyFn(paymentData?.cashPayment, {symbol: '$'})}
                            </span>
                        </ReadTextField>
                    </Grid>
                    <Grid item xs={6}>
                        <ReadTextField label="信用卡付款金額">
                            <span className={Number(paymentData?.cardPayment) > 0 ? 'font-weight-bold text-success' : ''}>
                                {formatCurrencyFn(paymentData?.cardPayment, {symbol: '$'})}
                            </span>
                        </ReadTextField>
                    </Grid>
                </Grid>
            </Card.CardContent>
        </Card>
    )
};
export default OrderPaymentInfoSection;
